import { render } from "./Orders.vue?vue&type=template&id=1233d4ac"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__